import { render } from "./cashier_walkin_index.vue?vue&type=template&id=92667376&scoped=true"
import script from "./cashier_walkin_index.vue?vue&type=script&lang=js"
export * from "./cashier_walkin_index.vue?vue&type=script&lang=js"

import "./cashier_walkin_index.vue?vue&type=style&index=0&id=92667376&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92667376"]])

export default __exports__